// @dynamic
import {ItpLauncherComponent} from '@features/scenarios-core/components/itp-luncher/itp-launcher.component';
import {RootDynamicComponentHelper} from '@shared/helpers/root-dynamic-component-helper';
import {ScenarioConceptualGraphFilterDialogComponent} from '@shared/components/dialog-components/scenario-conceptual-graph-filter-dialog/scenario-conceptual-graph-filter-dialog.component';

export class ScenariosDynamicComponentHelper {
    public static components: any;

    public static init() {
        if (ScenariosDynamicComponentHelper.components) {
            return;
        }
        const components = {};
        components['ItpLauncherComponent'] = ItpLauncherComponent;
        ScenariosDynamicComponentHelper.components = components;
        RootDynamicComponentHelper.merge(components);
    }

    public static getComponentArray(): any[] {
        ScenariosDynamicComponentHelper.init();
        const componentArray = [];
        ScenariosDynamicComponentHelper.components = componentArray;
        Object.keys(ScenariosDynamicComponentHelper.components).forEach(key => {
            componentArray.push(ScenariosDynamicComponentHelper.components[key]);
        });
        return componentArray;
    }

    public static register(key: string, component: any) {
        ScenariosDynamicComponentHelper.components[key] = component;
        RootDynamicComponentHelper.register(key, component);
    }
}
